---
de:
  overview:
    48hrs: "(48 Stunden)"
    dir:
      asc: "▼"
      desc: "▲"
    effect_overflow_tip: Überprüfung, ob der aktuelle maximale Produktionswert für dieses Kraftwerk korrekt ist
    precipitation: Niederschlag (48-Stunden Vorhersage)
    sensor_values:
      above_limit: Über dem Grenzwert
      below_limit: Unterhalb des Grenzwertes
      within_limits: Innerhalb der Grenzen
    sort:
      current_effect: Aktuelle Produktion
      current_income: Umsatz
      name: Name
      precipitation: Niederschlag
      rated_power_mw: Max Leistung
      utilization: Verwertung
    variants:
      advanced: Erweiterte Übersicht
      basic: Einfache Übersicht
